import { TextButton } from '@wix/design-system';
import React from 'react';
const Noop = () => {
  return null;
};
export const getTranslationTags = props => {
  const {
    url
  } = props || {};
  const Link = url ? /*#__PURE__*/React.createElement(TextButton, {
    as: "a",
    href: url,
    size: "tiny",
    target: "_blank"
  }) : /*#__PURE__*/React.createElement(Noop, null);
  return {
    Link,
    voucher: /*#__PURE__*/React.createElement(Noop, null),
    b: /*#__PURE__*/React.createElement("b", null)
  };
};
//# sourceMappingURL=getTranslationTags.js.map